import React, { Fragment } from 'react';

import MessageCard from 'components/Shared/MessageCard/MessageCard';
import { breakpoints } from 'styles/cp';

interface Props {
  header?: string;
  text?: string;
  messageValues?: Record<string, any>;
}

const GeneralPageMessage: React.FC<Props> = ({ header, text, messageValues }) => {
  if (!text) {
    return null;
  }

  return (
    <Fragment>
      <div className="card-wrapper">
        <MessageCard
          header={header}
          text={text}
          messageValues={messageValues}
          errorMessageIconPosition={'start'}
        />
      </div>
      <style jsx>{`
        @keyframes opacityChange {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .card-wrapper {
          animation-name: opacityChange;
          animation-duration: 2s;
          @media screen and (max-width: ${breakpoints.md}) {
            padding: 0 16px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default GeneralPageMessage;
